import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { FieldValues, UseFormReturn, Path } from 'react-hook-form';
import DatePicker from './DatePicker';

type DatePickerProps<T extends FieldValues> = {
	control: UseFormReturn<T>['control'];
	name: Path<T>;
	label: string;
	placeholder: string;
	isFullWidth?: boolean;
	isDisabledFn?: (date: Date) => boolean;
};

const RHFDatePicker = <T extends FieldValues>(props: DatePickerProps<T>) => {
	const { control, name, label, ...rest } = props;
	return (
		<FormField
			control={control}
			name={name}
			render={({ field }) => (
				<FormItem className="flex flex-col">
					<FormLabel className="w-[240px]">{label}</FormLabel>
					<DatePicker TriggerWrapper={FormControl} value={field.value} onChange={field.onChange} {...rest} />
					<FormMessage />
				</FormItem>
			)}
		/>
	);
};

export default RHFDatePicker;
